import { bl_fi_incoming_ecom_einvoice_matched_history_RowClass } from '../../dbschema/bl_fi_incoming_ecom_einvoice_matched_history.model';
import { BaseContainerModel } from '../base-container.model';

export class IncomingEcomEInvoiceMatchedHistoryContainerModel extends BaseContainerModel {
    bl_fi_incoming_ecom_einvoice_matched_history: bl_fi_incoming_ecom_einvoice_matched_history_RowClass = new bl_fi_incoming_ecom_einvoice_matched_history_RowClass();
}
